'use strict';

import { connectRefinementList } from 'react-instantsearch/connectors';

export default connectRefinementList(({ items, title, className, children }) => {
	return items.length ? <div className={ className }>{ children }</div> : null;
});
